import { HttpApiEndpoint, HttpApiGroup } from "@effect/platform";
import { Context } from "effect";
import { Schema as S } from "effect";
const identity = { token: S.NonEmptyString, email: S.NonEmptyString };
export const AcceptInvitationPayload = S.Struct({
    ...identity,
    password: S.NonEmptyString,
});
export const AcceptSsoInvitationPayload = S.Struct({
    ...identity,
    provider: S.NonEmptyString,
});
const failure = { code: S.String, message: S.String };
export const InvitationFailure = S.Struct({
    ...failure,
    status: S.Literal(400),
});
export const InvitationUnauthorized = S.Struct({
    ...failure,
    status: S.Literal(401),
});
export const InvitationForbidden = S.Struct({
    ...failure,
    status: S.Literal(403),
});
export const InvitationCredentialsError = S.Union(InvitationFailure, InvitationUnauthorized, InvitationForbidden);
/**
 * Public credential exchange: the signed invite token authorizes activation,
 * so the group carries no principal middleware and an anonymous request
 * reaches it through the /web/v1 bridge.
 */
export const invitationsGroup = HttpApiGroup.make("invitations")
    .add(HttpApiEndpoint.post("checkCode", "/users/registration-code/check")
    .setPayload(S.Struct({ unique_key: S.NonEmptyString }))
    .addSuccess(S.Array(S.Struct({ user_id: S.UUID }))))
    .add(HttpApiEndpoint.post("accept", "/users/invite/accept")
    .setPayload(AcceptInvitationPayload)
    .addSuccess(S.Void, { status: 204 })
    .addError(InvitationFailure, { status: 400 })
    .addError(InvitationUnauthorized, { status: 401 })
    .addError(InvitationForbidden, { status: 403 }))
    .add(HttpApiEndpoint.post("acceptSso", "/users/invite/accept/sso")
    .setPayload(AcceptSsoInvitationPayload)
    .addSuccess(S.Void, { status: 204 })
    .addError(InvitationFailure, { status: 400 })
    .addError(InvitationUnauthorized, { status: 401 })
    .addError(InvitationForbidden, { status: 403 }));
export class InvitationAcceptance extends Context.Tag("@pima/web-api/InvitationAcceptance")() {
}
//# sourceMappingURL=invitations.js.map